export const SET_LOADING_STATUS = "SET_LOADING_STATUS";
export const SET_LOADED_STATUS = "SET_LOADED_STATUS";
export const SET_TEAM_DISCUSSION = "SET_TEAM_DISCUSSION";
export const SET_ADD_CREATOR_TO_TEAM = "SET_ADD_CREATOR_TO_TEAM";
export const SET_TEAM_MEMBERS_INVITE_MODE = "SET_TEAM_MEMBERS_INVITE_MODE";
